
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"<SINGLE_COLOR>":"Einfarbig","<CLASSIFICATION>":"Mehrfarbig","<HIGHLIGHTING>":"Regelbasiert"},"en":{"<SINGLE_COLOR>":"Single-color","<CLASSIFICATION>":"Multi-color","<HIGHLIGHTING>":"Rule-based"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();